import { useHoverSubmenu } from '@components/v2/ui/Menu/hooks/useHoverSubmenu';
import { useState } from 'react';
import storage from '../../../../../../hooks/useStorage/useStorage';
import { useApplicationContext } from '../../../../../../modules/context/ApplicationContext/ApplicationContext';
import {
  getBrandInfo,
  getStoreInfo,
} from '../../../../../../modules/context/ApplicationContext/applicationContext.utils';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { useFindTeams } from '../../../../../../services/modules/users/users.queries';
import { formatCompleteName } from '../../../../../../utils/formatters';
import { buildTeamGroups } from '../../../../components/UserMenu/hooks/useUserMenu/useUserMenu.utils';

export const useOfflineUserMenu = () => {
  const { translate } = useTranslation();
  const { state, changeTeamInOffline } = useApplicationContext();
  const { data: teamsData } = useFindTeams({ enabled: true });

  const [mainAnchorEl, setMainAnchorEl] = useState<HTMLElement | null>(null);
  const teamSubmenu = useHoverSubmenu();

  const teamsWithOfflineAccess = (teamsData?.data ?? []).filter((team) =>
    storage.getOfflineEncryptionKey(team.id),
  );

  const { name: brandName, logoUrl: brandLogoUrl } = getBrandInfo(state.user?.brand);
  const { name: storeName, logoUrl: storeLogoUrl } = getStoreInfo(state.user?.store);
  const entityName = brandName || storeName;

  const closeAll = () => {
    setMainAnchorEl(null);
    teamSubmenu.close();
  };

  return {
    buttonProps: {
      entityName,
      entityInitial: entityName ? entityName[0].toUpperCase() : '',
      entityLogoUrl: brandLogoUrl || storeLogoUrl,
      isOpen: Boolean(mainAnchorEl),
      onClick: (e: React.MouseEvent<HTMLElement>) => setMainAnchorEl(e.currentTarget),
    },
    menuProps: {
      anchorEl: mainAnchorEl,
      onClose: closeAll,
      userName: formatCompleteName(state.user?.name, state.user?.surname, ''),
      userInitial: state.user?.name?.[0]?.toUpperCase() ?? '',
      userLogoUrl: state.user?.profileUrl,
      isAdminTeceo: false,
      visibility: { account: false, externalLinks: false, signOut: false },
      userItemProps: { show: false, onClick: () => undefined },
      teamItemProps: {
        ...teamSubmenu.triggerProps,
        show: true,
        isOpen: teamSubmenu.isOpen,
      },
      onAccountClick: () => undefined,
      onAdminClick: () => undefined,
      onSignOutClick: () => undefined,
      onExternalLinkClick: () => undefined,
    },
    teamMenuProps: {
      ...teamSubmenu.submenuProps,
      groups: buildTeamGroups({
        teams: teamsWithOfflineAccess,
        selectedTeamId: state.user?.id,
        translate,
      }),
      onSelect: (id: string) => {
        const team = teamsWithOfflineAccess.find((currentTeam) => currentTeam.id === id);

        if (team) {
          changeTeamInOffline(team);
        }

        closeAll();
      },
    },
  };
};
